import sanityClient from '@sanity/client';

// * Documentation: https://www.sanity.io/docs/js-client
export default sanityClient({
    projectId: "t68qumw6",
    dataset: "production",
    apiVersion: '2022-11-11', // use a UTC date string
    useCdn: true, // `false` if you want to ensure fresh data
})